import { useEventStore } from '../stores/event';

export const hubSignInName = () => useEventStore().event?.value?.login_event_name || window.store?.subdomain || '';
